export async function waitForDocumentLoaded(): Promise<void> {
  if (document.readyState === 'complete') {
    return;
  }
  return new Promise<void>((resolve) => addEventListener('load', () => resolve()));
}
